import axios from 'axios';

const ESTADO_LABELS = {
  901: 'Sin Cargar',
  902: 'Pend. Aprob.',
  903: 'Devolución',
  905: 'Reingreso',
  904: 'Cargada',
};

const DOC_LABELS = {
  0: 'Sin Doc',
  1: 'Parcial',
  2: 'Completa',
};

export default function ReclamosTabla({ solicitudes }) {
  // Sort by fecha de ingreso — oldest first (no filtering, page handles it)
  const parseFecha = f => {
    if (!f) return new Date(0);
    const [dia, mes, anio] = f.split('/').map(Number);
    return new Date(anio, mes - 1, dia);
  };

  const sorted = [...solicitudes].sort(
    (a, b) => parseFecha(a.fechaSolicitud) - parseFecha(b.fechaSolicitud)
  );

  const handleRowClick = async (nroStro) => {
    if (!nroStro) return;
    try {
      const response = await axios.get(`https://reclamosback.agsseguros.online/apiReclamos/empleadosSolicitudes/obtener-id/${nroStro}`);
      const data = response.data;
      if (data?.id) {
        window.open(`/#/${data.id}`, '_blank');
      }
    } catch (error) {
      console.error('Error buscando el ID:', error);
    }
  };

  const getDiasAntiguedad = (fechaSolicitud) => {
    if (!fechaSolicitud) return 0;
    const [dia, mes, anio] = fechaSolicitud.split('/').map(Number);
    const fecha = new Date(anio, mes - 1, dia);
    const hoy = new Date();
    const diff = Math.floor((hoy - fecha) / (1000 * 60 * 60 * 24));
    return diff;
  };

  const getAntiguedadClass = (dias) => {
    if (dias > 30) return 'reclamos-antiguedad--urgente';
    if (dias > 14) return 'reclamos-antiguedad--alerta';
    return '';
  };

  return (
    <div className='dashboard-card reclamos-tabla-card'>
      <div className='dashboard-card-header'>
        <span className='dashboard-card-title'>
          <i className='bi bi-list-ul'></i>
          Reclamos — Prioridad por Antigüedad
        </span>
        <span className='dashboard-card-badge'>{sorted.length} reclamos</span>
      </div>

      {/* Table */}
      <div className='reclamos-table-wrapper'>
        <table className='reclamos-table'>
          <thead>
            <tr>
              <th>Nro Stro</th>
              <th>Fecha Ingreso</th>
              <th>Antigüedad</th>
              <th>Patente Aseg</th>
              <th>Patente 3ro</th>
              <th>Estado</th>
              <th>Carpeta</th>
              <th>Documentación</th>
              <th>Últ. Mod</th>
            </tr>
          </thead>
          <tbody>
            {sorted.map((s, idx) => {
              const dias = getDiasAntiguedad(s.fechaSolicitud);
              return (
                <tr
                  key={s.nroStro || idx}
                  className={dias > 30 ? 'reclamos-row--old' : ''}
                  onClick={() => handleRowClick(s.nroStro)}
                >
                  <td className='reclamos-table-nrostro'>{s.nroStro}</td>
                  <td>{s.fechaSolicitud}</td>
                  <td>
                    <span className={`reclamos-antiguedad ${getAntiguedadClass(dias)}`}>
                      {dias}d
                    </span>
                  </td>
                  <td>{s.patenteAseg || '—'}</td>
                  <td>{s.patenteRec || '—'}</td>
                  <td>
                    <span className={`reclamos-estado-badge reclamos-estado-badge--${s.estado}`}>
                      {ESTADO_LABELS[s.estado] || 'Desconocido'}
                    </span>
                  </td>
                  <td>
                    <span className={s.docOffice ? 'reclamos-carpeta-si' : 'reclamos-carpeta-no'}>
                      {s.docOffice ? 'SI' : 'NO'}
                    </span>
                  </td>
                  <td>
                    <span className={`reclamos-doc-badge reclamos-doc-badge--${s.estadoDoc ?? 0}`}>
                      {DOC_LABELS[s.estadoDoc] || 'Sin Doc'}
                    </span>
                  </td>
                  <td style={{ fontSize: '11px', color: '#94a3b8' }}>{s.ultMod || '—'}</td>
                </tr>
              );
            })}
            {sorted.length === 0 && (
              <tr>
                <td colSpan={9} style={{ textAlign: 'center', padding: '32px', color: '#94a3b8' }}>
                  <i className='bi bi-inbox' style={{ fontSize: '24px', display: 'block', marginBottom: '8px' }}></i>
                  Sin reclamos para mostrar
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
